@if (!disabled) {
  <mat-form-field class="booking-date-range">
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" (click)="openDatePicker()" [min]="minDate">
      <input matStartDate formControlName="start" placeholder="Start date">
      <input matEndDate formControlName="end" placeholder="End date">
    </mat-date-range-input>
    <mat-datepicker-toggle data-test="datepicker-toggle-button" matIconSuffix [for]="picker" (click)="openDatePicker()" class="picker-icon"></mat-datepicker-toggle>

  <mat-date-range-picker #picker [touchUi]="touchUi" (opened)="updateCalendar()" (monthSelected)="updateCalendar()" [calendarHeaderComponent]="DateHeaderComponent">
    <mat-date-range-picker-actions class="calendar-actions">
      <div class="calendar-errors">
        <div *ngFor="let error of calendarErrors" class="error-message">
          {{error}}
        </div>
      </div>
      <div class="action-section">
        <span class="number-of-selected-nights">{{ numberOfNightsSelected ?? 0 }} Nights Selected</span>
        <div class="action-buttons">
          <button matDateRangePickerCancel (click)="clearDates()" class="cnt-button" data-test="calendar-cancel-btn">Clear</button>
          <button matDateRangePickerApply class="cnt-button" [disabled]="!okEnabled" [ngClass]="{ 'btn-disabled': !okEnabled }" data-test="calendar-confirm-btn">Ok</button>
        </div>
      </div>
    </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field>
}
@else {
  <div class="disabled-date-range">
    <span>{{ fromDate?.toJSDate() | date: 'mediumDate' }}</span>
    <span> - </span>
    <span>{{ toDate?.toJSDate() | date: 'mediumDate' }}</span>
  </div>
}
